import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=6e45ea64&scoped=true"
import script from "./StudentView.vue?vue&type=script&lang=js"
export * from "./StudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e45ea64",
  null
  
)

export default component.exports